import { JOBS_POST_AD_EVENTS } from '../../constants/events';
import { difference, copyObject, isDebugMode } from '../../utils';
import {defaultJobsPostAdRequestState} from '../../utils/JobsPostAd';


const JobsPostAdRequestReducer = (state = defaultJobsPostAdRequestState, actions) => {
  switch (actions.type) {
    case JOBS_POST_AD_EVENTS.AD_ATTRIBUTE_CHANGE : {
      let oldState =  copyObject(state);
      state = Object.assign({}, state, actions.payload);

      if(isDebugMode()) {
        console.log('New attributes added ', difference(state, oldState));
      }
      break;
    }
    case JOBS_POST_AD_EVENTS.UPDATE_PACK_SELECTED : {
      state = Object.assign({}, state);
      state.others.selectedPack = actions.payload.selectedPack;
      state.others.selectedSubPack = actions.payload.selectedSubPack;
      break;
    }
    default:
      return state;
  }

  return state;
};

export default JobsPostAdRequestReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/JobsPostAdReducer/jobsPostAdRequestReducer.js